module.exports = __webpack_public_path__ + "img/touxiang.0e493b15.png";